import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import AskUpgrade from '../../components/AskUpgrade.js';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import Notification from '../../components/Notification';

class Analytics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading:true,
            data:[],
            startDateId:'1',
            stopDateId:'2',
            initialStart:moment(moment().subtract(7, 'days')),
            initialEnd:moment(),
            startDate:moment(moment().subtract(7, 'days')),
            endDate:moment(),
            focusedInput:null,
            askUpgrade:false,
        }

        this.onDatesChange = this.onDatesChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
        this.daterange = this.daterange.bind(this);

    }

    daterange() {
        return <span>between <span style={{fontWeight:'bold'}}>{moment(this.state.startDate).format('MM/DD/YYYY')}</span> and <span style={{fontWeight:'bold'}}>{moment(this.state.endDate).format('MM/DD/YYYY')}</span></span>
    }


    componentWillMount() {
        this.get();
    }

    get(from = false,to = false) {
        if(!from) {
            from = this.state.startDate;
        }
        if(!to) {
            to = this.state.endDate;
        }
        this.setState({
            'isLoading':true,
        });

        if(!to || !from) {
            this.setState({
                startDate:this.state.initialEnd,
                endDate:this.state.initialStart
            });

            Notification.error('Error: Invalid date, resetting to last month.');
            to = this.state.initialEnd;
            from = this.state.initialStart;
        }

        axios.get(`/insights`, {
            params: {
                'from':moment(from).format('YYYY-MM-DD'),
                'to':moment(to).format('YYYY-MM-DD')
            }
        })
            .then(res => {
                this.setState({
                    'isLoading':false,
                    'data':res.data
                });
            });
    }



    onDatesChange({ startDate, endDate }) {
        if(this.props.general.settings.PACKAGE_INSIGHTS != '1') {
            this.setState({askUpgrade:true});
        }else{
            this.setState({ startDate, endDate });
            this.get(startDate,endDate);
        }
    }

    onFocusChange(focusedInput) {
        this.setState({ focusedInput });
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={false} />
            );
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-graph-up"></i> Insights</span>
                    <div className="pull-right" >
                    <DateRangePicker
                        startDateId={this.state.startDateId}
                        endDateId={this.state.stopDateId}
                        onDatesChange={this.onDatesChange}
                        onFocusChange={this.onFocusChange}
                        startDateId="start_date"
                        endDateId="end_date"
                        small={true}
                        focusedInput={this.state.focusedInput}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        isOutsideRange={() => {return false}}
                        anchorDirection="left"
                        showDefaultInputIcon
                    />
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Insights | Crall.io" />


                    <div className="row">
                        <div className="col-sm-4">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-graph-up" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className="counter-number blue-grey-500">{this.state.data.average_order_sum}</span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Average order sum</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-sm-4">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-graph-up" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className="counter-number blue-grey-500">{this.state.data.revenue}</span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Revenue</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-graph-up" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className="counter-number blue-grey-500">{this.state.data.orders}</span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Orders</div>
                                </div>
                            </div>
                        </div>


                    </div>




                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Most visited product {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>
                                                #
                                            </th>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Views
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.most_viewed_product.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.name}</td>
                                                    <td>{i.c}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Most visited category {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Views
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.most_viewed_category.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.name}</td>
                                                    <td>{i.c}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>











                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Most valuable customer {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Sum
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.valuable_customer.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.name}</td>
                                                    <td>{i.c}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Most sold product {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Sold
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.most_sold.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.name}</td>
                                                    <td>{i.c}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>








                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Most busy hours in period {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Time
                                            </th>
                                            <th>
                                                Orders
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.busy.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.at}</td>
                                                    <td>{i.c}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Best revenue source {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Source
                                            </th>
                                            <th>
                                                Sum
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.referrer.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.referrer}</td>
                                                    <td>{i.sum}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card card-shadow p-0">
                                <div className="card-header card-header-transparent card-header-bordered">
                                    <button type="button" className="btn btn-sm btn-dark">
                                        <i className="icon wb-graph-up"></i>
                                    </button>
                                    <span className="m-l-15 font-weight-400">Top 10 revenue by category {this.daterange()}</span>
                                </div>
                                <div className="card-block p-0">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Category
                                            </th>
                                            <th>
                                                Revenue
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.most_sold_category.map((i,num) => {
                                            return (
                                                <tr key={num}>
                                                    <td>{num+1}</td>
                                                    <td>{i.name}</td>
                                                    <td>{i.formatted}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>











                    <AskUpgrade onAccept={(e) => { this.setState({askUpgrade:false}); this.props.router.push(General.Link('/settings/billing/plan')) }} onClose={() => {this.setState({askUpgrade:false})}} param={this.state.askUpgrade} title="Upgrade required" body="To use this feature you must upgrade to Standard Plus" />

                </div>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Analytics = connect(mapStateToProps,mapDispatchToProps)(Analytics);
export default Analytics;



// WEBPACK FOOTER //
// ./containers/analytics/analytics.js